/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class AthenaeumTransferRoute extends Route {
  // Services
  @service
  store;

  model() {
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return this.store.query('person', { type: PersonType.LEARNER, statuses });
  }

  // afterModel loads the caregivers that the list shows.
  afterModel() {
    return this.store.query('person', { type: PersonType.CAREGIVER });
  }
}
